import { Supplier } from "../../supplier/supplier";

export class NewReferenceRequest {
  isbn!: string;
  supplierId!: string;
  title!: string;
  price!: number;
}